'use client'

import { ReactNode, useEffect } from 'react'
import { TolgeeProvider, TolgeeStaticData, useTolgeeSSR } from '@tolgee/react'

import { useRouter } from './navigation'
import { TolgeeBase } from './shared'

const tolgee = TolgeeBase().init()

interface TolgeeProviderProps {
  locales: TolgeeStaticData
  locale: string
  children: ReactNode
}

export function TolgeeNextProvider({
  locales,
  locale,
  children,
}: TolgeeProviderProps) {
  const router = useRouter()
  const tolgeeSSR = useTolgeeSSR(tolgee, locale, locales)

  useEffect(() => {
    const { unsubscribe } = tolgeeSSR.on('permanentChange', () => {
      router.refresh()
    })

    return unsubscribe
  }, [router, tolgeeSSR])

  return (
    <TolgeeProvider tolgee={tolgeeSSR} options={{ useSuspense: false }}>
      {children}
    </TolgeeProvider>
  )
}
